module.exports = __webpack_public_path__ + "static/img/szafa_6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/szafa_6.svg
// module id = xzXB
// module chunks = 0